import { LoadableApp } from 'ui-seeker/core'
import { HO_DESTINATION, HO_COMPETENCE, HO_RAW, HO_ADMIN } from 'app/config'

const Destination = LoadableApp(import('./Destination'))
const Competence = LoadableApp(import('./Competence'))
const Raw = LoadableApp(import('./Raw'))
const Admin = LoadableApp(import('./Admin'))

const PageRoutes = [
    { path: HO_DESTINATION.path, component: Destination, needLogin: true },
    { path: HO_COMPETENCE.path, component: Competence, needLogin: true },
    { path: HO_RAW.path, component: Raw, needLogin: true },
    { path: HO_ADMIN.path, component: Admin, needLogin: true }
]

export default PageRoutes